module.exports = class AuthToken {
  constructor(access
  /*: string*/
  , refresh
  /*: ?string*/
  , version
  /*: ?number*/
  ) {
    this.access = access;
    this.refresh = refresh;
    this.version = version;
  }

};